<template>
  <component :is="iconName" class="base-icon" :class="[dynamicClasses]"></component>
</template>

<script>
import _ from 'lodash'
const validSizes = ['xxs', 'xs', 's', 'm', 'l']

export default {
  props: {
    // Available icons are registered in carbon-icons.js
    icon: {
      type: String,
      required: true
    },
    size: {
      type: String,
      required: false,
      default: 'm',
      validator: (value) => _.includes(validSizes, value)
    },
    rotate: {
      type: String,
      required: false,
      default: ''

    }
  },
  computed: {
    iconName() {
      return _.upperFirst(_.camelCase(this.icon))
    },
    sizeClass() { return `base-icon--${this.size}` },
    rotateClass() { return this.rotate ? `base-icon--${this.rotate}` : '' },
    // binding multiple dynamic classes on <component> not possible,
    // adds comma (,) to concatenated class string. Bug? Hence dynamicClasses solution
    dynamicClasses() { return `${this.sizeClass} ${this.rotateClass}` }
  }
}
</script>

<style lang="scss" scoped>
.base-icon {
  box-sizing: content-box;
  @media (prefers-reduced-motion: no-preference) {
    transition: all .4s ease;
  }
}

// SIZES
.base-icon--xxs {
  height: 14px;
  width: 14px;
  min-width: 14px;
}

.base-icon--xs {
  height: 16px;
  width: 16px;
  min-width: 16px;
}
.base-icon--s {
  height: 20px;
  width: 20px;
  min-width: 20px;
}
.base-icon--m {
  height: 24px;
  width: 24px;
  min-width: 24px;
}

.base-icon--l {
  height: 32px;
  width: 32px;
  min-width: 32px;

  @include media('to-small') {
    height: 24px;
    width: 24px;
    min-width: 24px;
  }
}

// ROTATIONS
.base-icon--180 {
  transform: rotate(180deg);
}
</style>
